import { FormlyExtension, FormlyFieldConfig } from '@ngx-formly/core';

import { Patterns } from '@shared/constants/patterns';

// iOS "Smart Punctuation" turns a typed ' into ’ (and " into “ ”). The name allowlist mirrors the backend's and
// has only the straight quotes, so "Driver’s" failed on a phone but passed on a desktop (KOR-15192).
export const straightenQuotes = (value: unknown): unknown =>
  typeof value === 'string' ? value.replace(/[‘’‚‛′]/gu, "'").replace(/[“”„‟″]/gu, '"') : value;

// Every field validated against the name allowlist reads a typographic quote as the straight one it stands for
export const typographicQuotesExtension: FormlyExtension = {
  prePopulate: (field: FormlyFieldConfig) => {
    if (field.props?.pattern === Patterns.GENERIC_NAME) {
      field.parsers = [...(field.parsers ?? []), straightenQuotes];
    }
  },
};
